import { Directive, HostListener, Input, inject } from '@angular/core';
import { FtSectionsComponent } from './sections.component';

/**
 * Native-Angular port of the AngularJS `ftSectionTrigger` directive.
 * `<a ftSectionTrigger="current">…</a>` — click activates the parent
 * `<ft-sections>`'s 'current' section.
 *
 * `@Host()` injection isn't usable on a directive that isn't a component, so
 * we accept the parent through ordinary DI (it must be present in the
 * injector tree — `<ft-sections>` is its host); if it isn't, the click is a
 * no-op and we log once.
 */
@Directive({
    // Match BOTH the camelCase Angular form AND the v1 kebab-case attribute —
    // some legacy CSS targets `[ft-section-trigger="X"]` (audiences nav, the
    // journeys carousel cards), so the kebab attribute needs to land on the
    // DOM for the styling to apply.
    selector: '[ftSectionTrigger], [ft-section-trigger]',
    host: {
        '[attr.ft-section-trigger]': 'sectionName',
    },
    standalone: false
})
export class FtSectionTriggerDirective {
  @Input('ftSectionTrigger') sectionName!: string;
  @Input('ft-section-trigger') set kebabSectionName(v: string) { this.sectionName = v; }

    private readonly sections = inject(FtSectionsComponent);

  @HostListener('click')
  onClick(): void {
    this.sections?.activate(this.sectionName);
  }
}
